/*
  TWRD wishlist store — single source of truth for the localStorage wishlist.
  Key: twrd_wishlist. Item: { handle, id, title, image, url, price, savedAt }.

  Consumers: snippets/twrd-product-actions.liquid (PDP heart),
  snippets/twrd-card-wishlist.liquid (product-card heart),
  snippets/twrd-nav-wishlist.liquid (header badge),
  sections/twrd-wishlist.liquid (wishlist page).

  Emits BOTH 'twrd:wishlist-changed' (legacy, already consumed by the theme)
  and 'twrd:wishlist:change' on document, plus mirrors cross-tab 'storage'.
*/
(function () {
  if (window.TwrdWishlist) return;

  var KEY = 'twrd_wishlist';

  function read() {
    try {
      var parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
      return true;
    } catch (_) {
      return false;
    }
  }

  function emit(list) {
    var detail = { count: list.length, items: list };
    try {
      document.dispatchEvent(new CustomEvent('twrd:wishlist-changed', { detail: detail }));
      document.dispatchEvent(new CustomEvent('twrd:wishlist:change', { detail: detail }));
    } catch (_) {}
  }

  function normalize(item) {
    if (!item || !item.handle) return null;
    return {
      handle: String(item.handle),
      id: item.id != null ? String(item.id) : '',
      title: item.title || '',
      image: item.image || '',
      url: item.url || '',
      price: item.price || '',
      savedAt: item.savedAt || Date.now()
    };
  }

  var store = {
    KEY: KEY,
    get: read,
    count: function () { return read().length; },
    has: function (handle) {
      if (!handle) return false;
      return read().some(function (p) { return p.handle === handle; });
    },
    add: function (item) {
      var clean = normalize(item);
      if (!clean) return false;
      var list = read();
      if (list.some(function (p) { return p.handle === clean.handle; })) return true;
      list.unshift(clean);
      write(list);
      emit(list);
      return true;
    },
    remove: function (handle) {
      if (!handle) return false;
      var list = read();
      var next = list.filter(function (p) { return p.handle !== handle; });
      if (next.length === list.length) return false;
      write(next);
      emit(next);
      return true;
    },
    /* Returns true when the item ends up saved, false when removed. */
    toggle: function (item) {
      var clean = normalize(item);
      if (!clean) return false;
      if (store.has(clean.handle)) {
        store.remove(clean.handle);
        return false;
      }
      store.add(clean);
      return true;
    },
    clear: function () {
      write([]);
      emit([]);
    },
    /* cb(list) now and on every change. Returns an unsubscribe function. */
    subscribe: function (cb) {
      if (typeof cb !== 'function') return function () {};
      var handler = function () { try { cb(read()); } catch (_) {} };
      document.addEventListener('twrd:wishlist:change', handler);
      window.addEventListener('storage', function (e) { if (e.key === KEY) handler(); });
      handler();
      return function () { document.removeEventListener('twrd:wishlist:change', handler); };
    }
  };

  window.TwrdWishlist = store;

  /* Cross-tab writes only fire 'storage'. Re-broadcast as our own events so
     every consumer can listen to one channel. */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    emit(read());
  });
})();
